import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "email-confirmation-banner",
  templateUrl: "./email-confirmation-banner.component.html",
  styleUrls: ["./email-confirmation-banner.component.scss"],
  standalone: false,
})
export class EmailConfirmationBannerComponent {
  @Input() title: string =  "confirm_email.title";
  @Input() subtitle: string = "confirm_email.email_sent_success";

  @Output() confirm = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();
}
